module.exports = __webpack_public_path__ + "img/county-wayne.1d99edcc.png";